import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
    Button,
    Typography,
    Container,
} from "@material-ui/core";

const LoginInitView = () => {

    return (
        <Container className="container-home">

            <div style={{ textAlign: "center", marginTop: 40 }}>
                <Typography variant="h4" gutterBottom>
                    Panel para usuarios autorizados Dashport
                </Typography>
                <Typography variant="subtitle1">
                    Si eres organizador de eventos y no tienes una cuenta de usuarios
                    autorizados, ponte en contacto con info@dashport.run
                </Typography>

                <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    to="/login"
                    style={{
                        margin: "20px",
                        padding: "20px",
                        width: "300px",
                        fontSize: 20,
                    }}
                >
                    Iniciar Sesión
                </Button>
                <br />
                <Button
                    variant="outlined"
                    color="secondary"
                    component={Link}
                    to="/registro"
                    style={{
                        margin: "20px",
                        padding: "20px",
                        width: "300px",
                        fontSize: 20,
                    }}
                >
                    Crear Cuenta
                </Button>
            </div>
        </Container>
    );
};

export default LoginInitView;
